import Icon from '../Icon';
import { FormItem } from '../Form';
import { Datepicker } from '../Datepicker';
import { compareDates } from '../../utilities';

type DateFilterProps<T> = {
  toName: StringKeyOf<T>;
  fromName: StringKeyOf<T>;
};

const DateFilter = <T extends {} = any>({
  toName,
  fromName,
}: DateFilterProps<T>) => {
  return (
    <div className="flex flex-row gap-sm">
      <FormItem<any> name={fromName} label="">
        <Datepicker />
      </FormItem>
      <div className="inline-flex items-center justify-center shrink-0">
        <Icon icon="dash" width={false} />
      </div>
      <FormItem<any>
        name={toName}
        label=""
        hideRenderedError
        validate={(_value, values) => {
          return compareDates(values[toName], values[fromName]) === -1
            ? 'Must be greater than Start Date'
            : null;
        }}
      >
        <Datepicker endOfDay />
      </FormItem>
    </div>
  );
};

export default DateFilter;
